// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Nw-z","tooltipWrapper":"Ow-z","icon":"Pw-z","tooltip":"Qw-z","content":"Rw-z"};